import { render, staticRenderFns } from "./idealista.vue?vue&type=template&id=abb39e46&scoped=true&"
import script from "./idealista.vue?vue&type=script&lang=js&"
export * from "./idealista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb39e46",
  null
  
)

export default component.exports